export default class ScrollToForm {
    constructor(element) {
        this.el = element;
        this.init();
    }
    init() {
        this.el.scrollIntoView(this.el, {block: 'center'});
    }
}